import CardLayout from './CardLayout';

export default CardLayout;